<template lang="html">
  <div>
    <overwatchLoader id='loader' v-if='!site'/>
    <model path="/static/barriere/barriereChangeHorizontalV1/model/" :content="model" :format='43'></model>
    <div id='barriereChangeHorizontalV1' class='d-flex flex-column justify-content-center align-items-center' v-if='site'>
      <div id='master' class='d-flex flex-column align-items-center'>
        <img id="siteLogo" :src='siteLogo'></img>
        <div id="title">
          <span class='lg1'>{{ $tlang(lg1, 'barriere.change.title') }}</span>
          <span class='lg2'>{{ $tlang(lg2, 'barriere.change.title') }}</span>
        </div>
        <div id="change" class='d-flex flex-row justify-content-between flex-wrap' :class="{ large: isLarge }">
          <div class='cellContainer d-flex flex-row' v-for="change in filteredChange">
            <div class='cell d-flex flex-row align-items-center'>
              <img class="flag flag-icon-169" :class="getFlag(change.mer_unity)"></img>
              <div class='money'>{{ change.mer_unity }}</div>
              <div class='price ml-auto'>{{ change.mer_value }}</div>
            </div>
          </div>
        </div>
        <div id="update_date" v-if="updateDate"><span class='label lg1'>{{ $tlang(lg1, 'barriere.change.updateDate') }}</span> <span class='label lg2'>{{ $tlang(lg2, 'barriere.change.updateDate') }}</span> <span class='date lg2'>{{this.updateDate}}</span></div>
        <div id="subtitles">
          <span class="lg1" v-for="subtitle in subtitleLg1">{{subtitle}}</span>
          <span class="lg2" v-for="subtitle in subtitleLg2">{{subtitle}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
  import OverwatchLoader from '../../../../loader/overwatch'
  import model from '../../../../debug/model'
  import '@/tools/flags/css/flag-icon.css'

  var take = require('lodash/take')

  export default {
    name: 'barriere-change-horizontal-v-1-vue',
    props: [],
    components: {
      OverwatchLoader,
      model
    },
    mounted () {
      this.$dm.getData(this.$route)
    },
    data () {
      return {
        model: ['LB Courchevel_ecran_change_4par3_V7_01drapeau.jpg', 'LB Courchevel_ecran_change_4par3_V7_02drapeaux.jpg', 'LB Courchevel_ecran_change_4par3_V7_03drapeaux.jpg', 'LB Courchevel_ecran_change_4par3_V7_04drapeaux.jpg', 'LB Courchevel_ecran_change_4par3_V7_05drapeaux.jpg', 'LB Courchevel_ecran_change_4par3_V7_06drapeaux.jpg', 'LB Courchevel_ecran_change_4par3_V7_07drapeaux.jpg', 'LB Courchevel_ecran_change_4par3_V7_08drapeaux.jpg', 'LB Courchevel_ecran_change_4par3_V7_09drapeaux.jpg', 'LB Courchevel_ecran_change_4par3_V7_10drapeaux.jpg']
      }
    },
    methods: {
      getFlag (unit) {
        return 'flag-icon-' + unit.toLowerCase()
      }
    },
    computed: {
      netStatus () {
        return this.$store.state.connected
      },
      site () {
        let site = this.$store.getters.site
        return site
      },
      change () {
        return this.site.get('change').get('data')
      },
      user () {
        return this.$store.getters.user
      },
      device () {
        return this.$store.getters.device
      },
      siteLogo () {
        let logo = this.change.site_logo.split('/').pop()
        return `/static/barriere/barriereChangeHorizontalV1/logosSites/${logo}`
      },
      lg1 () {
        return this.change.languages[0].name.toLowerCase()
      },
      lg2 () {
        return this.change.languages[1].name.toLowerCase()
      },
      filteredChange () {
        let count = this.changeCount ? this.changeCount : 10
        return take(this.change[this.change.languages[0].id].exchangeRate.rates, count)
      },
      subtitleLg1 () {
        return this.change[this.change.languages[0].id].exchangeRate.group_subtitles.col_1
      },
      subtitleLg2 () {
        return this.change.languages[1] && this.change[this.change.languages[1].id].exchangeRate.group_subtitles.col_1
      },
      isLarge () {
        return this.filteredChange.length <= 2
      },
      changeCount () {
        return this.$route.query.changeCount
      },
      updateDate () {
        let date = this.change[this.change.languages[0].id].exchangeRate.updateDate
        if (date) {
          let d = date.split('-')
          return `${d[2]}/${d[1]}/${d[0]}`
        } else {
          return ''
        }
      }
    },
    watch: {
      netStatus (newStatus, oldStatus) {
        console.log('netStatus update', oldStatus, newStatus)
        // Get data on connection status change
        if (oldStatus) { // getData must not be done the first time
          console.log('netStatus getdata')
          this.$dm.getData(this.$route)
        }
      },
      user (newUser, oldUser) {
        console.log('User update', oldUser, newUser)
        // Get data when user is logged
        if (oldUser && newUser) {
          console.log('user getdata')
          this.$dm.getData(this.$route)
        }
      },
      device (newDevice, oldDevice) {
        console.log('Device update', oldDevice, newDevice)
        // refresh data on device update
        if (oldDevice && oldDevice._objCount && newDevice) {
          console.log('device getdata')
          this.$dm.getData(this.$route)
        }
      }
    }
  }
</script>

<style scoped lang="scss" scoped>
$srcWidth: 1440;
$srcHeight: 1080;
@import "../../../_barriere.scss";

#barriereChangeHorizontalV1 {
  width: 160vh; // https://www.alsacreations.com/article/lire/1490-comprendre-le-viewport-dans-le-web-mobile.html
  height: 100vh;
  background-color: white;

  .lg1 {
    color: black;
  }

  .lg2 {
    color: $gold;
  }

  #master {
    position: relative;
    width: 160vh;
    height: 100vh;
    background-color: white;

    #siteLogo {
      @include heightPercent43(275);
      @include widthPercent43(468);
      margin: 1.6vh;
      object-fit: contain;
    }

    #title {
      text-transform: uppercase;
      font-family: "Lucien-Bold";
      font-size: 2.6em;
      padding-bottom: 0.5vh;
      letter-spacing: 0.11vh;

      span + span {
        margin-left: 2em;
      }
    }

    #change {
      border-top: 1px solid $gold;
      border-bottom: 1px solid $gold;
      width: 85%;
      @include heightPercent43(476);

      &.large {
        .cellContainer {
          width: 100%;

          &:nth-of-type(odd), &:nth-of-type(even) {
            justify-content: center!important;
          }

          .cell {
            height: 100%;

            width: 60%;
          }

          & + .cellContainer {
            border-top: 1px solid$gold;
          }
        }
      }

      .cellContainer {
        width: 45%;

        /* https://keithclark.co.uk/articles/targeting-first-and-last-rows-in-css-grid-layouts/ */
        &:nth-child(2n + 1):nth-last-child(-n + 2),
        &:nth-child(2n + 1):nth-last-child(-n + 2) ~ div {
          .cell {
            border-bottom: none;
          }
        }

        &:nth-of-type(odd)
        {
          justify-content: flex-start!important;
        }

        &:nth-of-type(even)
        {
          justify-content: flex-end!important;
        }

        .cell {
          width: 100%;
          border-bottom: 1px solid $gold;
          border-collapse: collapse;
          border-spacing: 0px;

          .flag {
            @include widthPercent43(104);
            @include heightPercent43(60);
            object-fit: contain;
            margin-left: 1em;
            margin-right: 1em;
            background-size: contain;
          }

          .money {
            font-family: "Lucien-Thin";
            font-size: 1.5em;
          }

          .price {
            font-family: "Lucien-Book";
            font-size: 2.5em;
            margin-right: 0.5em;
            padding-top: 0.2em;
          }
        }
      }
    }

    #subtitles {
      width: 85%;
      font-size: 1.35em;
      line-height: 1.2em;

      span {
        &:after {
          content: "  .  ";
        }
      }
    }

    #update_date {
      width: 85%;
      font-size: 1.3em;
      text-align: right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/barriere/change/horizontal/v1/barriereChangeHorizontalV1.vue